import React from 'react'
import { Link } from 'react-router-dom'
// import logoValijaYa from '../../imagenes/logo/logovalijaya.png'
// import logoHoteles from '../../imagenes/logo/logo_hoteles.png'
//import logoSoloHotel from '../../imagenes/logo/soloHotel@2x.png'
//import logoValijaYa from '../../imagenes/logo/ic_valijaYa.png'
// import trabajaConNosotros from '../../imagenes/logo/trabajaConNosotros.png'
//import trabajaConNosotros from '../../imagenes/logo/ic_trabajaConNosotros.png'
import valijaYa from '../../imagenes/logo/valija-ya-ic.png'
import agencia from '../../imagenes/logo/agencia-ic.png'
import paquete from '../../imagenes/logo/paquete-ic.png'
import franquicia from '../../imagenes/logo/franquicia-ic.png'
import trabajaConNosotros from '../../imagenes/logo/busqueda_ic_mini.png'

const BarraNavegacion = (props) => {
  const { origen, isCDR } = props;
  let tipoCliente =  sessionStorage.getItem('tipoCliente');

  return (
    <div className={`blue-nav ${isCDR ? 'cdrColor' : ''}`}>
      <div className="container-fluid">
        <ul className="">
          <li className="col-xl-1 col-lg-1 col-md-2 col-sm-6 col-6">
            <Link to='/'>
                <img alt="Paquetes" title="Paquetes" src={paquete}  />
                <span style={{marginLeft: '4px'}}>
                Paquetes
                </span>
            </Link>
            {/* <Link to='/'><i className="material-icons">card_travel</i> paquetes</Link> */}
          </li>
          {tipoCliente !== "AGE" ?
          <li className="col-xl-1 col-lg-1 col-md-2 col-sm-6 col-6">
            <Link to='/buscador-de-agencias'>
              <img alt="Buscar Agencias" title="Buscar agencias" src={agencia}   /> 
              <span style={{marginLeft: '4px', lineHeight: 'normal'}}>
              Buscar Agencias
              </span>
              </Link>
          </li> : null }
          {/*{(!tipoCliente || tipoCliente === "IND") &&
            <li className="d-none d-lg-inline-flex col-xl-1 col-lg-1">

              <a href='https://www.pedraza.com.ar/turnos/'><i className="material-icons">event</i> Turnos</a>
            </li>
           */}
          {tipoCliente !== "IND" && tipoCliente ?
          <li className="col-xl-1 col-lg-1 col-md-2 col-sm-6 col-6">
            <Link to='/carteleras'>
            <span style={{marginLeft: '4px', lineHeight: 'normal'}}>
              <i className="material-icons" style={{verticalAlign: 'sub'}}>wallpaper</i>Vidriera</span>
            </Link>
          </li> : null }
           {/* <li className="col-xl-1 col-lg-1 col-md-2 col-sm-6 col-6" style={{verticalAlign: 'sub'}}>
             <Link to='/hoteles'> 
              <img style={{'marginBottom': '-8px'}} alt="Hoteles" title="Hoteles" src={logoSoloHotel}  />  
            </Link> 
          <a href='https://www.pedraza.com.ar/cdr/' target="_blank" rel="noopener noreferrer"  style={{'float':'left'}} className="btnValijaYa">
              <img style={{'marginBottom': '-8px'}} alt="Hoteles" title="Hoteles" src={logoHoteles}  />  
            </a>
          </li> */}
          <li className="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-6 menu__valijaYa">
            <Link to={`/paquetes-turisticos/${origen}/promociones`} className="btnValijaYa">
              <img alt="Valija Ya" title="Valija Ya" src={valijaYa}  />
              <span style={{marginLeft: '4px', lineHeight: 'normal'}}>
                <span>Promociones</span> <br />
                <span style={{fontWeight: 'bolder'}}> De Ultimo Momento</span>
              </span>
            </Link>
          </li>
          {/*
          <li className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-6 menu__franquisiaVirtual">
           <Link to={`/franquiciaVirtual`} className="">
              <img alt="Franquicia" title="Franquicia" src={franquicia}  />
              <span style={{marginLeft: '4px', lineHeight: 'normal'}}>
                  <span>Solicita</span>  <br />
                  <span style={{fontWeight: 'bolder'}}> tu Franquicia Virtual</span>
                </span>
            </Link>
          </li>
          <li className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-6 menu__trabajaConNosotros" style={{marginBottom: '-2px'}}>
           <Link to={`/trabajaConNosotros`} style={{marginBottom: '-6px'}}>
              <img alt="Trabaja con Nosotros" title="Trabaja con Nosotros" src={trabajaConNosotros}  />
              <span style={{marginLeft: '4px', lineHeight: 'normal'}}>
                  <span>Busqueda</span>  <br />
                  <span> de Personal</span>
                </span>
            </Link>
          </li>
          */}
        </ul>

      </div>
    </div>
  )
}

export default BarraNavegacion



// WEBPACK FOOTER //
// ./src/components/Global/BarraNavegacion.js